<section class="mt-2">
    <div class="container-fluid px-0">
        <div class="mb-5 d-flex align-items-center justify-content-between gap-3   mt-2 flex-wrap ct_gap_10">
            <h4 class="ct_fs_24 ct_fw_600 mb-0">KPI Dashboard</h4>
            <div class="d-flex align-items-center" style="gap: 20px;">
                <!-- <div class="form-group d-flex align-items-center ct_gap_10   mb-0">
                    <label for="" class="ct_white_space_nowrape mb-0">Year
                    </label>

                    <div
                        class="selectyear ct_calander_input col ct_calender_38 ct_month_light_green ct_calender_font_size">
                        <p-calendar class="w-100" ngModel name="year" year [(ngModel)]="year" styleClass="pcalender"
                            view="year" dateFormat="yy" inputId="yearpicker" (ngModelChange)="onYearChange()"
                            [showIcon]="true"></p-calendar>
                    </div>
                </div> -->

                <div class="form-group d-flex align-items-center ct_gap_10   mb-0">
                    <label for="" class="ct_white_space_nowrape mb-0">Frequency
                    </label>

                    <p-dropdown
                        class="finput ct_input_white_bg13 ct_res_100_767 ct_w_150_select_345 ct_select_2_drop_white ct_input_dark_text_145"
                        ngModel placeholder="Select" [options]="dateFormat" optionLabel="shortBy" optionValue="shortBy"
                        styleClass="facilitydropdown" [(ngModel)]="dateFormatType"
                        (ngModelChange)="onFormatChange($event)" #country="ngModel" required>
                    </p-dropdown>
                </div>
                <div class="d-flex align-items-center ct_gap_10 ct_res_100_767">
                    <ng-container *ngIf="dateFormatType == 'Annually'">
                        <div class="form-group d-flex align-items-center ct_gap_10  ct_res_100_767 mb-0 et_flex_wrap_1400"
                            *ngIf="selectedFormatType == 'Aggregate'">
                            <label for="" class="ct_white_space_nowrape mb-0">Start Year
                            </label>

                            <div
                                class="selectyear ct_calander_input col ct_calender_38 ct_month_light_green ct_calender_font_size">
                                <p-calendar class="w-100" ngModel name="year" year styleClass="pcalender" view="year"
                                    [(ngModel)]="startDate" dateFormat="yy" inputId="yearpicker" [showIcon]="true"
                                    (ngModelChange)="onYearChange()"></p-calendar>
                            </div>
                        </div>
                        <div
                            class="form-group d-flex align-items-center ct_gap_10  ct_res_100_767 mb-0 et_flex_wrap_1400">
                            <label for="" class="ct_white_space_nowrape mb-0">{{selectedFormatType == 'Aggregate' ?
                                'End Year' : 'Year'}}
                            </label>
                            <div
                                class="selectyear ct_calander_input col ct_calender_38 ct_month_light_green ct_calender_font_size">
                                <p-calendar class="w-100" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}"
                                    styleClass="pcalender" view="year" dateFormat="yy" inputId="yearpicker"
                                    [showIcon]="true" (ngModelChange)="onYearChange()"></p-calendar>
                            </div>
                        </div>

                    </ng-container>

                    <ng-container *ngIf="dateFormatType !== 'Annually' ">
                        <div class="form-group d-flex align-items-center ct_gap_10  ct_res_100_767 mb-0">
                            <label for="" class="ct_white_space_nowrape mb-0">Year
                            </label>

                            <div
                                class="selectyear ct_calander_input col ct_calender_38 ct_month_light_green ct_calender_font_size">
                                <p-calendar class="w-100" styleClass="pcalender" view="year" [(ngModel)]="endDate"
                                    [ngModelOptions]="{standalone: true}" dateFormat="yy" inputId="yearpicker"
                                    [showIcon]="true" (ngModelChange)="onYearChange()"></p-calendar>
                            </div>
                        </div>
                        <!-- <div class="form-group d-flex align-items-center ct_gap_10  ct_res_100_767 mb-0 et_flex_wrap_1400" *ngIf="selectedFormatType == 'Compare'">
                            <label for="" class="ct_white_space_nowrape mb-0">{{dateFormatType == 'Monthly' ? 'Select Month' : 'Select Quarter'}}
                            </label>
                            <div 
                                class="selectyear ct_calander_input col ct_calender_38 ct_month_light_green ct_calender_font_size">
                                <p-multiSelect
                                class="ct_select_2_full_width12 ct_input_dark_text_145 ct_multi_select_overlap_text_302 et_select__38_678"
                                [options]="dateFormatType == 'Monthly' ? monthData : quarterData" placeholder="Select value" optionLabel="name"
                                optionValue="value" appendTo="body"></p-multiSelect>
                            </div>
                        </div> -->
                    </ng-container>
                </div>

            </div>
        </div>

        <div class="d-flex  justify-content-between gap-3 align-items-start   mt-2 ct_flex_column_767"
            style="gap: 20px;">

            <div class="d-flex align-items-center gap-3 et_flex_end_1400  ct_gap_10 flex-wrap ct_flex_column_767 w-100">
                <div
                    class="form-group d-flex align-items-center ct_gap_10 flex-wrap ct_res_100_767 mb-0 et_flex_wrap_1400">
                    <label for="" class="ct_white_space_nowrape mb-0">Facility
                    </label>

                    <p-multiSelect
                        class="ct_select_2_full_width12 ct_input_dark_text_145 ct_multi_select_overlap_text_302 et_select__38_678"
                        [options]="facilityData" placeholder="Select facilities" optionLabel="AssestType"
                        optionValue="id" [(ngModel)]="selectedFacility" ngModel
                        (onChange)="onFacilityChange(selectedFacility)"></p-multiSelect>

                    <div class="ct_emission_menu_link">
                        <ul class="ps-0 mb-0">
                            <li class="mb-0">
                                <a style="height: 38px;cursor: pointer;"
                                    [ngClass]="selectedFormatType == 'Aggregate' ? 'ct_active' : ''"
                                    (click)="onFormatTypeChange('Aggregate')">Aggregate </a>
                            </li>
                            <li class="mb-0">
                                <a [ngClass]="selectedFormatType == 'Compare' ? 'ct_active' : ''"
                                    style="height: 38px;cursor: pointer;"
                                    (click)="onFormatTypeChange('Compare')">Compare</a>
                            </li>

                        </ul>
                    </div>

                </div>



                <div class="ml-auto d-flex align-items-center">
                    <button class="GroupButton ct_assign_package_btn129 ct_animation_btn_121 w-auto px-3 mt-0"
                        (click)="visible2 = true"> Set Target

                    </button>
                    <div class="ct_how_use_tooltip_main ml-auto">
                        <i class="fa-solid fa-circle-question" (click)="isHowtoUse = !isHowtoUse"></i>
                        <div class="ct_how_use_tooltip_cnt" [ngClass]="isHowtoUse ? 'ct_active' : ''">
                            <div>
                                <p class="mb-1 ">The <strong>KPI Dashboard</strong> provides a visual overview of your
                                    organization’s
                                    emission trends and KPI performance across facilities. It helps in monitoring
                                    progress, comparing facility performance, and identifying opportunities for emission
                                    reduction and efficiency improvement.
                                </p>
                                <h5 class="ct_fs_16 mt-3 mb-2">Key Features:
                                </h5>

                                <ul style="list-style: disc;" class="mb-0 pl-4">
                                    <li>Interactive graphs and charts displaying GHG emissions and KPI metrics.

                                    </li>
                                    <li>Choose between:
                                        <ol style="list-style: numric;" class="mb-0 pl-4">
                                            <li>Aggregated view of KPIs across multiple facilities.
                                            </li>
                                            <li>Comparison view to evaluate performance between two or more facilities.
                                            </li>
                                        </ol>
                                    </li>
                                    <li>Select time periods: Monthly, Quarterly, or Annual data based on entries made in
                                        the Emission Inventory section.

                                    </li>
                                </ul>

                                <h5 class="ct_fs_16 mb-2 mt-3">Target Setting:


                                </h5>
                                <ol style="list-style: dics;" class="mb-2 pl-4">
                                    <li>Users can set targets for specific KPIs by selecting the KPI, entering the
                                        target value, and choosing the frequency (monthly, quarterly, or annually).

                                    </li>
                                    <li>Set targets appear as red dotted lines on the KPI graphs for clear visual
                                        tracking.

                                    </li>

                                </ol>
                                <h5 class="ct_fs_16  mb-2 mt-3">Steps to Use:



                                </h5>
                                <ol style="list-style: numric;" class="mb-2 pl-4">
                                    <li> Select the facility/facilities you want to analyze.
                                    </li>
                                    <li>Choose the KPI from the dropdown list.
                                    </li>
                                    <li>Select the timeline (monthly/quarterly/annually) for data visualization.
                                    </li>
                                    <li>View graph with actual performance data.
                                    </li>
                                    <li>To set a target:
                                        <ol style="list-style: circle;" class="mb-2 pl-4">
                                            <li>Tap on the target option.
                                            </li>
                                            <li>Select the KPI.
                                            </li>
                                            <li>Enter the target value (unit will auto-populate).
                                            </li>
                                            <li>Select frequency and save.
                                            </li>

                                        </ol>
                                    </li>


                                </ol>

                                <h5 class="ct_fs_16 mb-2 mt-3 ">Access Rights:
                                </h5>
                                <ol class="pl-4" style="list-style: disc;">
                                    <li>All user roles (Super-Admin, Admin, Manager, Data Preparer and Auditor) have
                                        access to view the KPI Dashboard.

                                    </li>
                                    <li>Target setting can be done by Super-Admin, Admin, and Manager roles only.

                                    </li>

                                </ol>

                            </div>






                        </div>
                    </div>
                </div>



            </div>




        </div>

        <div class="mt-4">
            <div class="mb-4"><button class="GroupButton ct_assign_package_btn129 ct_animation_btn_121 w-auto px-3 mt-0"
                    (click)="saveKpi()">Save
                </button></div>
            <div class="row ">
                <div class="col-lg-6 mb-4">
                    <div class="form-group mb-0">

                        <p-dropdown
                            class="finput ct_res_100_767 ct_input_white_bg13 ct_w_150_select_345 ct_select_2_drop_white ct_input_dark_text_145"
                            ngModel placeholder="Select KPIs" [options]="kpiList" optionLabel="kpi_name"
                            optionValue="id" [(ngModel)]="selectedKpi1" (ngModelChange)="onGraphChange($event ,'1')"
                            styleClass="facilitydropdown" #country="ngModel" required>
                        </p-dropdown>
                        <div class="mt-4" *ngIf="graph1">
                            <apx-chart [series]="graph1.series" [chart]="graph1.chart" [dataLabels]="graph1.dataLabels"
                                [plotOptions]="graph1.plotOptions" [yaxis]="graph1.yaxis" [xaxis]="graph1.xaxis"
                                [annotations]="graph1.annotations" [legend]="graph1.legend" [colors]="graph1.colors"
                                [grid]="graph1.grid"></apx-chart>
                        </div>

                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group mb-0">

                        <p-dropdown
                            class="finput ct_res_100_767 ct_input_white_bg13 ct_w_150_select_345 ct_select_2_drop_white ct_input_dark_text_145"
                            ngModel placeholder="Select KPIs" [options]="kpiList" optionLabel="kpi_name"
                            optionValue="id" (ngModelChange)="onGraphChange($event ,'2')" styleClass="facilitydropdown"
                            [(ngModel)]="selectedKpi2" #country="ngModel" required>
                        </p-dropdown>
                        <div class="mt-4" *ngIf="graph2">
                            <apx-chart [series]="graph2.series" [chart]="graph2.chart" [dataLabels]="graph2.dataLabels"
                                [plotOptions]="graph2.plotOptions" [yaxis]="graph2.yaxis" [xaxis]="graph2.xaxis"
                                [legend]="graph2.legend" [annotations]="graph2.annotations" [colors]="graph2.colors"
                                [grid]="graph2.grid"></apx-chart>
                        </div>

                    </div>
                </div>


            </div>
        </div>
        <div class=" mt-4">

            <div class="row">
                <div class="col-lg-6 mb-4">
                    <div class="form-group mb-0">

                        <p-dropdown
                            class="finput ct_res_100_767 ct_input_white_bg13 ct_w_150_select_345 ct_select_2_drop_white ct_input_dark_text_145"
                            ngModel placeholder="Select KPIs" [options]="kpiList" optionLabel="kpi_name"
                            optionValue="id" (ngModelChange)="onGraphChange($event ,'3')" styleClass="facilitydropdown"
                            [(ngModel)]="selectedKpi3" #country="ngModel" required>
                        </p-dropdown>
                        <div class="mt-4" *ngIf="graph3">
                            <apx-chart [series]="graph3.series" [chart]="graph3.chart" [dataLabels]="graph3.dataLabels"
                                [plotOptions]="graph3.plotOptions" [yaxis]="graph3.yaxis" [xaxis]="graph3.xaxis"
                                [legend]="graph3.legend" [annotations]="graph3.annotations" [colors]="graph3.colors"
                                [grid]="graph3.grid"></apx-chart>
                        </div>

                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group mb-0">

                        <p-dropdown
                            class="finput ct_res_100_767 ct_input_white_bg13 ct_w_150_select_345 ct_select_2_drop_white ct_input_dark_text_145"
                            ngModel placeholder="Select KPIs" [options]="kpiList" optionLabel="kpi_name"
                            optionValue="id" (ngModelChange)="onGraphChange($event ,'4')" styleClass="facilitydropdown"
                            [(ngModel)]="selectedKpi4" #country="ngModel" required>
                        </p-dropdown>
                        <div class="mt-4" *ngIf="graph4">
                            <apx-chart [series]="graph4.series" [chart]="graph4.chart" [dataLabels]="graph4.dataLabels"
                                [plotOptions]="graph4.plotOptions" [yaxis]="graph4.yaxis" [xaxis]="graph4.xaxis"
                                [legend]="graph4.legend" [annotations]="graph4.annotations" [colors]="graph4.colors"
                                [grid]="graph4.grid"></apx-chart>
                        </div>

                    </div>
                </div>


            </div>
        </div>
        <div class=" mt-4">


            <div class="row">
                <div class="col-lg-6 mb-4">
                    <div class="form-group mb-0">

                        <p-dropdown
                            class="finput ct_res_100_767 ct_input_white_bg13 ct_w_150_select_345 ct_select_2_drop_white ct_input_dark_text_145"
                            ngModel placeholder="Select KPIs" [options]="kpiList" optionLabel="kpi_name"
                            optionValue="id" (ngModelChange)="onGraphChange($event ,'5')" styleClass="facilitydropdown"
                            [(ngModel)]="selectedKpi5" #country="ngModel" required>
                        </p-dropdown>
                        <div class="mt-4" *ngIf="graph5">
                            <apx-chart [series]="graph5.series" [chart]="graph5.chart" [dataLabels]="graph5.dataLabels"
                                [plotOptions]="graph5.plotOptions" [yaxis]="graph5.yaxis" [xaxis]="graph5.xaxis"
                                [legend]="graph5.legend" [annotations]="graph5.annotations" [colors]="graph5.colors"
                                [grid]="graph5.grid"></apx-chart>
                        </div>

                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group mb-0">

                        <p-dropdown
                            class="finput ct_res_100_767 ct_input_white_bg13 ct_w_150_select_345 ct_select_2_drop_white ct_input_dark_text_145"
                            ngModel placeholder="Select KPIs" [options]="kpiList" optionLabel="kpi_name"
                            optionValue="id" (ngModelChange)="onGraphChange($event ,'6')" styleClass="facilitydropdown"
                            [(ngModel)]="selectedKpi6" #country="ngModel" required>
                        </p-dropdown>
                        <div class="mt-4" *ngIf="graph6">
                            <apx-chart [series]="graph6.series" [chart]="graph6.chart" [dataLabels]="graph6.dataLabels"
                                [plotOptions]="graph6.plotOptions" [yaxis]="graph6.yaxis" [xaxis]="graph6.xaxis"
                                [legend]="graph6.legend" [colors]="graph6.colors" [annotations]="graph6.annotations"
                                [grid]="graph6.grid"></apx-chart>
                        </div>

                    </div>
                </div>


            </div>
        </div>

    </div>
</section>


<p-dialog [(visible)]="visible2" [breakpoints]="{'960px': '75vw'}" [style]="{width: '60vw'}">
    <p-header *ngIf="FormEdit === false"> Set Target </p-header>
    <p-header *ngIf="FormEdit === true"> Edit Target </p-header>

    <div class="modal-body text-white text-style Dashboard-tab ct_vertically_scroll" style="max-height: 680px;">
        <div class="col-md-12 table-responsive">
            <table class="table ct_home_office_table">
                <thead class="thead-dark">
                    <tr>

                        <th scope="col">KPI</th>
                        <th scope="col">Target</th>
                        <th scope="col">Unit</th>
                        <th scope="col">Target Type</th>

                    </tr>
                </thead>
                <tbody #commuteTable>

                    <tr *ngFor="let rows of targerKpisData; index as i">

                        <td>
                            <p-dropdown class="ct_select_op_input ct_flex_1 ct_chev_icon_dark230"
                                [(ngModel)]="rows.kpi_id" [ngModelOptions]="{standalone: true}" [options]="kpiList"
                                (onChange)="onKpiChange(rows.kpi_id , i)" optionLabel="kpi_name" optionValue="id"
                                placeholder="Select kpi">
                            </p-dropdown>
                        </td>
                        <td>
                            <input type="text" class="form-control" style="width:150px;height:38px"
                                placeholder="Enter value" [(ngModel)]="rows.target"
                                [ngModelOptions]="{standalone: true}">
                        </td>
                        <td>
                            <input type="text" class="form-control" style="width:150px;height:38px"
                                placeholder="Select kpi" disabled [(ngModel)]="rows.unit"
                                [ngModelOptions]="{standalone: true}">
                        </td>
                        <td>
                            <p-dropdown class="ct_select_op_input ct_flex_1 ct_chev_icon_dark230"
                                [(ngModel)]="rows.target_type" [ngModelOptions]="{standalone: true}"
                                [options]="dateFormat" optionLabel="shortBy" optionValue="shortBy"
                                placeholder="Select type">
                            </p-dropdown>
                        </td>

                    </tr>
                    <p class=" ml-2 mt-5 trackingsubmitb" (click)="pushTargetKpis()">+ Add KPIs</p>
                </tbody>

                <p class=" ml-2 mt-5 trackingsubmitb" (click)="submitTarget()">Submit</p>
            </table>
        </div>
    </div>
</p-dialog>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate-pulse" [fullScreen]="true">
    <p style="color: white"> Fetching Data... </p>
</ngx-spinner>